// extracted by mini-css-extract-plugin
export default {"root":"Divider-root-1bde9eba83b266e61470011bf1c45c40"};